module.exports = __webpack_public_path__ + "static/media/Winner1.2373fa8d.png";